export default __webpack_public_path__ + "static/media/main.0ef154c6.mp4";